const dashboard = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-globe'
  }
]

const personal = [
  {
    title: true,
    name: 'Personal'
  },
  {
    name: 'My Activity Log',
    url: '/userlog',
    urlName: 'userlog',
    icon: 'icon-notebook'
  }
]

const gameData = [
  {
    title: true,
    name: 'Game Data'
  },
  {
    name: 'Pokemon',
    url: '/pokemon',
    icon: 'icon-disc',
    permission: ['PokemonView', 'PokemonAddView'],
    children: [
      {
        name: 'Search Database',
        url: '/pokemon',
        icon: 'icon-magnifier',
        permission: 'PokemonView'
      },
      {
        name: 'Add Pokemon',
        url: '/pokemon/add',
        icon: 'icon-plus',
        permission: 'PokemonAddView'
      }
    ]
  },
  {
    name: 'Global Vars',
    url: '/globalvars',
    icon: 'icon-globe',
    permission: 'GlobalVarsView'
  }
]

const pvp = [
  {
    title: true,
    name: 'PvP'
  },
  {
    name: 'Ladders',
    url: '/pvp/ladder',
    icon: 'fa fa-list-ol',
    permission: 'SavedLaddersView'
  },
  {
    name: 'Rules',
    url: '/pvp/rules',
    icon: 'fa fa-gavel',
    permission: 'PvpRulesView'
  },
  {
    name: 'Rewards',
    url: '/pvp/rewards',
    icon: 'fa fa-gift',
    permission: 'PvpRewardsView'
  },
  {
    name: 'Banlist',
    url: '/pvp/banlist',
    icon: 'fa fa-ban',
    permission: 'PvpBanlistView'
  },
  {
    name: 'Random Sets',
    url: '/pvp/random_sets',
    icon: 'fa fa-random',
    permission: 'PvpRandomSetsView'
  },
  {
    name: 'Suspect Matches',
    url: '/pvp/suspect_matches',
    icon: 'fa fa-legal',
    permission: 'SuspectMatches'
  }
]

const news = [
  {
    title: true,
    name: 'News'
  },
  {
    name: 'Website News',
    url: '/news/list',
    icon: 'icon-globe',
    permission: 'WebsiteNewsView'
  },
  {
    name: 'Client News',
    url: '/news/ingame',
    icon: 'icon-screen-desktop',
    permission: 'IngameNewsView'
  }
]

const moderation = [
  {
    title: true,
    name: 'Moderation'
  },
  {
    name: 'Watchlist',
    url: '/gm/watchlist',
    icon: 'icon-list',
    permission: 'WatchlistView'
  },
  {
    name: 'Session Time',
    url: '/gm/playtime',
    icon: 'fa fa-clock-o',
    permission: 'PlaytimeView'
  },
  {
    name: 'Chat Log',
    url: '/admin/chatlog',
    icon: 'fa fa-street-view',
    permission: 'ChatlogView'
  },
  {
    name: 'E-Mail Delivery',
    url: '/admin/email-bounces',
    icon: 'fa fa-envelope',
    permission: 'MailLogView'
  },
  {
    name: 'E-Mail Routing',
    url: '/admin/email-routing',
    icon: 'fa fa-random',
    permission: 'EmailRoutingView'
  },
  {
    name: 'Mass Ban',
    url: '/admin/massban',
    icon: 'icon-lock',
    permission: 'MassbanView'
  },
  {
    name: 'System Bans',
    url: '/admin/systembans',
    icon: 'fa fa-ban',
    permission: 'SystemBanView'
  }
]

const administration = [
  {
    title: true,
    name: 'Administration'
  },
  {
    name: 'Permissions',
    url: '/admin/permission',
    icon: 'icon-lock',
    permission: 'PermissionView'
  },
  {
    name: 'Audit Log',
    url: '/admin/auditlog',
    icon: 'fa fa-book',
    permission: 'AuditlogView'
  },
  {
    name: 'System Logs',
    url: '/admin/toolslog',
    icon: 'fa fa-terminal',
    permission: 'SystemLogView'
  }
]

const divider = { divider: true }

export default {
  items: [
    ...dashboard,
    ...personal,
    divider,
    ...gameData,
    divider,
    ...pvp,
    divider,
    ...news,
    divider,
    ...moderation,
    divider,
    ...administration
  ]
}
